import { ProblemDetails, ProblemDetailsError } from 'helpers/problemDetails';
import { useEffect } from 'react';
import { UseFormSetError } from 'react-hook-form';
import { Benchmark, DayRange, Job } from 'api/errorCodes';

function getErrorKey({ code, propertyName }: ProblemDetailsError) {
  switch (code) {
    case Job.NameInUse:
    case Benchmark.NameInUse:
      return 'name';
    case Job.DayRangeFromDayCannotEqualToDay:
    case Job.DayRangeFromDayMustBeMonthEnd:
      return 'startDate';
    case Job.DayRangeToDayMustBeMonthEnd:
    case DayRange.ToDayCannotBeBeforeFromDay:
      return 'endDate';
    case Benchmark.NoLineItems:
      return undefined;
    default:
      return lowercaseFirst(propertyName);
  }
}

export function handleProblems(setError: any, problemDetails?: ProblemDetails) {
  problemDetails?.errors?.forEach((errorDetails) => {
    const errorKey = getErrorKey(errorDetails);
    if (errorKey) {
      setError(errorKey, { message: errorDetails.message });
    }
  });
}

export function useProblemsHandler(
  setError: UseFormSetError<any>,
  problemDetails?: ProblemDetails
) {
  useEffect(() => {
    handleProblems(setError, problemDetails);
  }, [problemDetails, setError]);
}

export function lowercaseFirst(str?: string) {
  if (!str || typeof str !== 'string') {
    return '';
  }

  if (str.length === 0) {
    return str;
  }

  return `${str.charAt(0).toLocaleLowerCase()}${str?.slice(1)}`;
}
